module.exports = __webpack_public_path__ + "static/who-we-are-banner.7c9bf7c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/banners/who-we-are-banner.jpg
// module id = 1460
// module chunks = 169858455373905